import { useEffect, useState } from "react";

const KEY = "wekit.schools.lastViewedStudent";

export function readLastViewedStudent(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function writeLastViewedStudent(id: string | null): void {
  if (typeof window === "undefined") return;
  try {
    if (id) window.localStorage.setItem(KEY, id);
    else window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** React-friendly reader that stays in sync when the value is written elsewhere. */
export function useLastViewedStudent(): string | null {
  const [value, setValue] = useState<string | null>(() => readLastViewedStudent());
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === KEY) setValue(e.newValue);
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  return value;
}
